// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__flYIQ","list":"BalanceDue_list__CA_z3","listRow":"BalanceDue_listRow__2tqXW","total":"BalanceDue_total__2dGmd"};